import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aUtdanning?: Valg<string>;
    bGrad?: Valg<string>;
    bxGrad?: Valg<string>;
    visVilkar: boolean;
}

export const UPDATE_VALG = 'UPDATE_AVALG';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export type ValgStateActionTypes = UpdateValgAction | ToggleVilkarAction;
